module.exports = __webpack_public_path__ + "img/fantasque-sans-mono-dark.7feeeaaa.png";